export function DragReady(scope, x, y) {
  return scope.StartDragInteraction(x, y);
}
